import script from "./council-purchasing-switching-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./council-purchasing-switching-modal.vue?vue&type=script&setup=true&lang=ts"

import "./council-purchasing-switching-modal.vue?vue&type=style&index=0&id=7a0bf927&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a0bf927"]])

export default __exports__